import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { from, of } from 'rxjs';
import { first, switchMap, finalize } from 'rxjs/operators';
import { UiAuthService } from '@fullyops/legacy/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiPushSubscriptionsAdapterService } from '@fullyops/data/push-subscriptions/api-adapter.service';
import { subscribePushNotifications } from '@fullyops/shared/push-subscriptions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  passwordHidden = true;
  loginForm: UntypedFormGroup;
  loading$ = new BehaviorSubject(false);
  returnUrl: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: UiAuthService,
    private snackBar: MatSnackBar,
    private pushApi: ApiPushSubscriptionsAdapterService,
  ) {
    this.authService.authorizedObs.subscribe((authorized) => {
      // redirect to home if already logged in
      if (authorized) {
        this.router.navigate(['/']);
      }
    });
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return this.openSnackBar('Fields not valid', 'Please try again');
    }

    this.loading$.next(true);
    this.authService
      .login(this.f.username.value, this.f.password.value)
      .pipe(
        first(),
        switchMap((data: HttpErrorResponse) => {
          if (data.error) {
            throw new Error('Login failed');
          }

          return from(subscribePushNotifications());
        }),
        switchMap((sub) => {
          if (sub != null) {
            return this.pushApi.create(sub);
          }
          return of(null);
        }),
        finalize(() => this.loading$.next(false)),
      )
      .subscribe({
        next: () => {
          this.router.navigate([this.returnUrl]);
        },
        error: (err) => {
          console.error('Login or push subscription failed:', err);
        },
      });
  }
}
